/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { ClockingInLogDto } from '../models/clocking-in-log-dto';
import { ClockingInLogDtoBaseResponse } from '../models/clocking-in-log-dto-base-response';
import { ClockingInLogDtoListBaseResponse } from '../models/clocking-in-log-dto-list-base-response';
import { ClockingInReportDtoBaseResponse } from '../models/clocking-in-report-dto-base-response';

@Injectable({
  providedIn: 'root',
})
export class ClockingInService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiClockingInAllLogsGet
   */
  static readonly ApiClockingInAllLogsGetPath = '/api/ClockingIn/all-logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInAllLogsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInAllLogsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ClockingInLogDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInAllLogsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInLogDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInAllLogsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInAllLogsGet$Plain(params?: {
  }): Observable<ClockingInLogDtoListBaseResponse> {

    return this.apiClockingInAllLogsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInLogDtoListBaseResponse>) => r.body as ClockingInLogDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInAllLogsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInAllLogsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ClockingInLogDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInAllLogsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInLogDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInAllLogsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInAllLogsGet$Json(params?: {
  }): Observable<ClockingInLogDtoListBaseResponse> {

    return this.apiClockingInAllLogsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInLogDtoListBaseResponse>) => r.body as ClockingInLogDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiClockingInTodaysLogsGet
   */
  static readonly ApiClockingInTodaysLogsGetPath = '/api/ClockingIn/todays-logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInTodaysLogsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInTodaysLogsGet$Plain$Response(params?: {
    date?: string;
  }): Observable<StrictHttpResponse<ClockingInLogDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInTodaysLogsGetPath, 'get');
    if (params) {
      rb.query('date', params.date, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInLogDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInTodaysLogsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInTodaysLogsGet$Plain(params?: {
    date?: string;
  }): Observable<ClockingInLogDtoListBaseResponse> {

    return this.apiClockingInTodaysLogsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInLogDtoListBaseResponse>) => r.body as ClockingInLogDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInTodaysLogsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInTodaysLogsGet$Json$Response(params?: {
    date?: string;
  }): Observable<StrictHttpResponse<ClockingInLogDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInTodaysLogsGetPath, 'get');
    if (params) {
      rb.query('date', params.date, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInLogDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInTodaysLogsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInTodaysLogsGet$Json(params?: {
    date?: string;
  }): Observable<ClockingInLogDtoListBaseResponse> {

    return this.apiClockingInTodaysLogsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInLogDtoListBaseResponse>) => r.body as ClockingInLogDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiClockingInAddLogPost
   */
  static readonly ApiClockingInAddLogPostPath = '/api/ClockingIn/add-log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInAddLogPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInAddLogPost$Plain$Response(params?: {
    body?: ClockingInLogDto
  }): Observable<StrictHttpResponse<ClockingInLogDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInAddLogPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInLogDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInAddLogPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInAddLogPost$Plain(params?: {
    body?: ClockingInLogDto
  }): Observable<ClockingInLogDtoBaseResponse> {

    return this.apiClockingInAddLogPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInLogDtoBaseResponse>) => r.body as ClockingInLogDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInAddLogPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInAddLogPost$Json$Response(params?: {
    body?: ClockingInLogDto
  }): Observable<StrictHttpResponse<ClockingInLogDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInAddLogPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInLogDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInAddLogPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInAddLogPost$Json(params?: {
    body?: ClockingInLogDto
  }): Observable<ClockingInLogDtoBaseResponse> {

    return this.apiClockingInAddLogPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInLogDtoBaseResponse>) => r.body as ClockingInLogDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiClockingInUpdateLogPut
   */
  static readonly ApiClockingInUpdateLogPutPath = '/api/ClockingIn/update-log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInUpdateLogPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInUpdateLogPut$Plain$Response(params?: {
    body?: ClockingInLogDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInUpdateLogPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInUpdateLogPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInUpdateLogPut$Plain(params?: {
    body?: ClockingInLogDto
  }): Observable<BooleanBaseResponse> {

    return this.apiClockingInUpdateLogPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInUpdateLogPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInUpdateLogPut$Json$Response(params?: {
    body?: ClockingInLogDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInUpdateLogPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInUpdateLogPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInUpdateLogPut$Json(params?: {
    body?: ClockingInLogDto
  }): Observable<BooleanBaseResponse> {

    return this.apiClockingInUpdateLogPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiClockingInArchiveLogDelete
   */
  static readonly ApiClockingInArchiveLogDeletePath = '/api/ClockingIn/archive-log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInArchiveLogDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInArchiveLogDelete$Plain$Response(params?: {
    clockingInLogId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInArchiveLogDeletePath, 'delete');
    if (params) {
      rb.query('clockingInLogId', params.clockingInLogId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInArchiveLogDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInArchiveLogDelete$Plain(params?: {
    clockingInLogId?: number;
    archive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiClockingInArchiveLogDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInArchiveLogDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInArchiveLogDelete$Json$Response(params?: {
    clockingInLogId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInArchiveLogDeletePath, 'delete');
    if (params) {
      rb.query('clockingInLogId', params.clockingInLogId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInArchiveLogDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClockingInArchiveLogDelete$Json(params?: {
    clockingInLogId?: number;
    archive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiClockingInArchiveLogDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiClockingInGetReportPost
   */
  static readonly ApiClockingInGetReportPostPath = '/api/ClockingIn/get-report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInGetReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInGetReportPost$Plain$Response(params?: {
    from?: string;
    to?: string;
    body?: Array<number>
  }): Observable<StrictHttpResponse<ClockingInReportDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInGetReportPostPath, 'post');
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInReportDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInGetReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInGetReportPost$Plain(params?: {
    from?: string;
    to?: string;
    body?: Array<number>
  }): Observable<ClockingInReportDtoBaseResponse> {

    return this.apiClockingInGetReportPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInReportDtoBaseResponse>) => r.body as ClockingInReportDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClockingInGetReportPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInGetReportPost$Json$Response(params?: {
    from?: string;
    to?: string;
    body?: Array<number>
  }): Observable<StrictHttpResponse<ClockingInReportDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClockingInService.ApiClockingInGetReportPostPath, 'post');
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClockingInReportDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClockingInGetReportPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClockingInGetReportPost$Json(params?: {
    from?: string;
    to?: string;
    body?: Array<number>
  }): Observable<ClockingInReportDtoBaseResponse> {

    return this.apiClockingInGetReportPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClockingInReportDtoBaseResponse>) => r.body as ClockingInReportDtoBaseResponse)
    );
  }

}
